import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import useBusinessConfig from '../hooks/useBusinessConfig';
import './BusinessTypeRoute.css';

/**
 * Blocks a route that isn't part of this merchant's trade.
 *
 * Deliberately separate from ModuleRoute. That one means "your plan doesn't
 * include this" and sells an upgrade; this means "your business doesn't have
 * this", where an upgrade prompt would be nonsense — no amount of money adds
 * Menus to a gym. Same reason the two live in different layers rather than
 * sharing module_access.
 *
 * Only guards direct URL entry: NavGroup already keeps these out of the
 * sidebar, so reaching this screen means someone typed or bookmarked the path.
 */
export default function BusinessTypeRoute({ module: moduleName, children }) {
  const { isHidden, label } = useBusinessConfig();
  const navigate = useNavigate();

  if (!isHidden(moduleName)) return children;

  return (
    <div className="btr-wrap">
      <div className="btr-card">
        <div className="btr-icon">
          <i className="ph ph-storefront" />
        </div>
        <h4 className="btr-title">Not available for your business</h4>
        <p className="btr-msg">
          This feature isn&apos;t part of the <strong>{label}</strong> setup, so it&apos;s
          been left out of your dashboard.
        </p>
        {/* "/" rather than /dashboard, which not every role can open. */}
        <button className="btr-btn" onClick={() => navigate('/', { replace: true })}>
          Take me back
        </button>
      </div>
    </div>
  );
}

BusinessTypeRoute.propTypes = {
  module: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};
